import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClick: () => void
}

const ButtonAddNew = ({ onClick }: Props) => (
  <Button type="secondary" onClick={onClick} iconName="add">
    {i18n.t('shift_management.default_shift.btn_new_shift_2')}
  </Button>
)

export default ButtonAddNew
